var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50001 5.50001C2.37201 5.50001 2.24401 5.45101 2.14601 5.35401L0.146006 3.35401C-0.0489941 3.15801 -0.0489941 2.84201 0.146006 2.64601C0.342006 2.45101 0.658006 2.45101 0.854006 2.64601L2.50001 4.29301L6.64601 0.146006C6.84201 -0.0489941 7.15801 -0.0489941 7.35401 0.146006C7.54901 0.342006 7.54901 0.658006 7.35401 0.854006L2.85401 5.35401C2.75601 5.45101 2.62801 5.50001 2.50001 5.50001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.23b8c5538f97c185a8bbf80c365bd49b.svg";
export { ForwardRef as ReactComponent };